import React from "react";
import PropTypes from "prop-types";

import { Icon } from "semantic-ui-react";

export function TypeInfo({ name, icon }) {
  return (
    <div
      style={{
        fontSize: "11pt",
        color: "grey",
        display: "flex",
        alignItems: "center",
      }}
    >
      <div>
        <Icon name={icon} color="grey" />
      </div>
      <div>{name}</div>
    </div>
  );
}

TypeInfo.propTypes = {
  name: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
};

TypeInfo.defaultProps = {};

export default TypeInfo;
